const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6796"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157545",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.806-846.926a3.155 3.155 0 0 1-2.319-.949 3.155 3.155 0 0 1-.949-2.319 3.155 3.155 0 0 1 .949-2.319 3.155 3.155 0 0 1 2.319-.949 3.155 3.155 0 0 1 2.319.949 3.155 3.155 0 0 1 .949 2.319 3.155 3.155 0 0 1-.949 2.319 3.155 3.155 0 0 1-2.319.949zm-7.191 12.726v-9.358a9.341 9.341 0 0 1-1.928-3 9.627 9.627 0 0 1-.686-3.63 9.465 9.465 0 0 1 2.849-6.956A9.46 9.46 0 0 1 189.8-860a9.467 9.467 0 0 1 6.957 2.85 9.461 9.461 0 0 1 2.851 6.956 9.627 9.627 0 0 1-.686 3.63 9.341 9.341 0 0 1-1.928 3v9.358l-7.191-2.288zm7.191-8.146a7.565 7.565 0 0 0 5.557-2.288 7.565 7.565 0 0 0 2.288-5.557 7.565 7.565 0 0 0-2.288-5.557 7.565 7.565 0 0 0-5.557-2.288 7.565 7.565 0 0 0-5.557 2.288 7.565 7.565 0 0 0-2.288 5.557 7.565 7.565 0 0 0 2.288 5.557 7.565 7.565 0 0 0 5.557 2.285z",
    transform: "translate(-174 863)",
    style: {
      fill: "#527ff2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseIcon);
export default __webpack_public_path__ + "static/media/license_icon.f4cdf740354182c7b54fe4051e4c7939.svg";
export { ForwardRef as ReactComponent };